import { useCurrentUserQuery } from 'apollo/queries';

const useUserId = () => {
  const { data } = useCurrentUserQuery();
  return data?.getMyData?.id;
};

export default useUserId;